import { z } from 'zod';

import { ESuluContentBlockTypes } from 'types/enums/sulu/EBackendData';

import ZSCBBase from './ZSCBBase';

const ZSCBDevelopmentProcess = ZSCBBase.extend({
  type: z.literal(ESuluContentBlockTypes.DEVELOPMENT_PROCESS),
});

export default ZSCBDevelopmentProcess;
